import { components, services } from '@/utils'

export default function(h) {
  if (this.checkPermissions(this.permission, this.accept)) {
    return h(
      components.select,
      {
        props: {
          value: this.proxy,
          label: this.label || this.getTranslate('commons.labels.owner'),
          hint: this.hint,
          service: services.users,
          query: this.computedQuery,
          itemTitle: 'username',
          labelMode: this.labelMode,
          flat: this.flat,
          dense: this.dense,
          itemsDisabled: this.itemsDisabled,
          details: !!this.hint || this.details,
          required: this.required,
          setRequiredOnMounted: this.setRequiredOnMounted,
          clearable: !this.required,
          autocomplete: this.autocomplete,
          clearItems: this.clearItems,
          loading: this.loading,
          disabled: this.loading || this.disabled,
          multiple: this.multiple
        },
        on: {
          input: event => {
            this.proxy = event
          }
        }
      }
    )
  }
}
